document.addEventListener("DOMContentLoaded", function() {
  const filterToggle = document.getElementById("filter-toggle");
  const filterPanel = document.getElementById("filter-panel");
  const filterClose = document.getElementById("filter-close");
  const applyFilters = document.getElementById("apply-filters");
  const clearFilters = document.getElementById("clear-filters");
  const cards = document.querySelectorAll(".product-card");
  const resultsCount = document.getElementById("results-count");

  /* ===== PANEL ===== */
  if (filterToggle) filterToggle.addEventListener("click", () => filterPanel.classList.add("active"));
  if (filterClose) filterClose.addEventListener("click", () => filterPanel.classList.remove("active"));

  /* ===== COMPTEUR ===== */
  function updateResultsCount() {
    const visible = Array.from(cards).filter(c => c.style.display !== "none").length;
    if (resultsCount) resultsCount.textContent = visible;
  }

  /* ===== SLIDER PRIX ===== */
  const rangeMin = document.getElementById("range-min");
  const rangeMax = document.getElementById("range-max");
  const priceMinInput = document.getElementById("price-min");
  const priceMaxInput = document.getElementById("price-max");

  function syncSlider() {
    let minVal = parseInt(rangeMin.value);
    let maxVal = parseInt(rangeMax.value);

    if (minVal > maxVal) {
      [rangeMin.value, rangeMax.value] = [maxVal, minVal];
      minVal = parseInt(rangeMin.value);
      maxVal = parseInt(rangeMax.value);
    }

    priceMinInput.value = minVal;
    priceMaxInput.value = maxVal;

    const track = document.querySelector(".slider-track");
    if (track) {
      const percent1 = (minVal / rangeMin.max) * 100;
      const percent2 = (maxVal / rangeMax.max) * 100;
      track.style.left = percent1 + "%";
      track.style.right = (100 - percent2) + "%";
    }
  }
  if (rangeMin && rangeMax) {
    rangeMin.addEventListener("input", syncSlider);
    rangeMax.addEventListener("input", syncSlider);
    syncSlider();
  }

  /* ===== FILTRAGE ===== */
  if (applyFilters) {
    applyFilters.addEventListener("click", () => {
      const brandChecks = document.querySelectorAll("input[name='brand']:checked");
      const colorChecks = document.querySelectorAll("input[name='color']:checked");
      const sizeChecks = document.querySelectorAll("input[name='size']:checked");

      const minPrice = parseFloat(priceMinInput.value) || 0;
      const maxPrice = parseFloat(priceMaxInput.value) || Infinity;

      cards.forEach(card => {
        let show = true;

        if (brandChecks.length > 0) {
          show = Array.from(brandChecks).some(cb => card.dataset.brand.includes(cb.value));
        }
        if (show && colorChecks.length > 0) {
          show = Array.from(colorChecks).some(cb => card.dataset.color.includes(cb.value));
        }
        if (show && sizeChecks.length > 0) {
          show = Array.from(sizeChecks).some(cb => card.dataset.size.includes(cb.value));
        }
        if (show) {
          const price = parseFloat(card.dataset.price);
          show = price >= minPrice && price <= maxPrice;
        }

        card.style.display = show ? "block" : "none";
      });

      filterPanel.classList.remove("active");
      updateResultsCount();
    });
  }

  /* ===== RESET ===== */
  if (clearFilters) {
    clearFilters.addEventListener("click", () => {
      document.querySelectorAll(".filter-content input[type='checkbox']").forEach(cb => cb.checked = false);
      if (priceMinInput) priceMinInput.value = 0;
      if (priceMaxInput) priceMaxInput.value = 1000;
      if (rangeMin) rangeMin.value = 0;
      if (rangeMax) rangeMax.value = 1000;

      cards.forEach(c => c.style.display = "block");
      updateResultsCount();
    });
  }

  /* ===== ACCORDÉON ===== */
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling;
      const isOpen = content.classList.contains("open");

      document.querySelectorAll(".accordion-header").forEach(h => h.classList.remove("active"));
      document.querySelectorAll(".accordion-content").forEach(c => c.classList.remove("open"));

      if (!isOpen) {
        header.classList.add("active");
        content.classList.add("open");
      }
    });
  });

  updateResultsCount();
});
